import { pushNotificationTokenActions } from './push-notification-token.actions';
import { CoreAppState } from '../core-app.state';
import {
  BaseResourceState,
  createBaseResourceReducer,
  initialResourceState,
} from '../create-base-resource-reducer';
import { PushNotificationTokenResourceTypeMappings } from '@aa/nest/resource';

export type PushNotificationTokenState =
  BaseResourceState<PushNotificationTokenResourceTypeMappings>;
export const initialPushNotificationTokenState: PushNotificationTokenState =
  initialResourceState;

export const pushNotificationTokenReducer = createBaseResourceReducer<
  PushNotificationTokenResourceTypeMappings,
  PushNotificationTokenState
>(initialPushNotificationTokenState, pushNotificationTokenActions);

export const selectPushNotificationTokenState = (state: CoreAppState) =>
  state.pushNotificationToken ?? initialPushNotificationTokenState;
